var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('sidebar',{attrs:{"routes":_vm.sidebarRoutes}}),_c('main-container',[_c('router-view'),_c('pagination-buttons',{attrs:{"pages":_vm.pages}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }